import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../Style/WebStyle.css';

const PreguntasFrecuentes = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs = [
    {
      id: 'faq1',
      pregunta: '¿Los préstamos en EasyCredit Colombia son legales?',
      respuesta:
        'Sí. En EasyCredit operamos bajo la normativa colombiana vigente. Prestamos dinero con recursos propios, una actividad permitida por la Ley 1480 de 2011 y el Decreto 1702 de 2015. Somos una empresa legalmente constituida, que cumple con todas las regulaciones del país.',
    },
    {
      id: 'faq2',
      pregunta: '¿Quién supervisa a EasyCredit?',
      respuesta:
        'EasyCredit está bajo la vigilancia de la Superintendencia de Industria y Comercio (SIC), conforme al Decreto 1074 de 2015. Esta entidad se encarga de proteger los derechos de los consumidores y garantizar que todas las operaciones se realicen de forma segura, ética y transparente.',
    },
    {
      id: 'faq3',
      pregunta: '¿Qué tipo de créditos ofrece EasyCredit?',
      respuesta:
        'Otorgamos créditos de consumo de bajo monto, pensados para atender necesidades personales, emergencias o gastos imprevistos. Nuestros préstamos son 100 % digitales, rápidos y sin papeleo, adaptados al perfil y capacidad de pago de cada cliente.',
    },
    {
      id: 'faq4',
      pregunta: '¿Qué tasa de interés maneja EasyCredit?',
      respuesta:
        'En EasyCredit aplicamos tasas dentro de los límites establecidos por el Banco de la República y la Superintendencia Financiera de Colombia. Siempre mostramos las condiciones antes de firmar el contrato, garantizando transparencia total y sin cobros ocultos.',
    },
    {
      id: 'faq5',
      pregunta: '¿EasyCredit cumple con la ley y garantiza transparencia en sus cobros?',
      respuesta:
        'Sí. En EasyCredit Colombia todos los costos, tasas e intereses son claros, visibles y explicados antes de aceptar el crédito. Cumplimos con la normatividad colombiana y trabajamos con total transparencia para que nuestros usuarios conozcan exactamente cuánto y por qué están pagando.\n\nAdemás, EasyCredit no es solo una plataforma de préstamos. Nuestra misión es impulsar la educación financiera de nuestros clientes. Por eso, en nuestra plataforma también encontrarás:\n- Cursos prácticos, como Excel básico.\n- Asesoramiento personalizado para fortalecer tu perfil crediticio.\n- Guías y recomendaciones para un manejo responsable del crédito y tus finanzas personales.\n\nEn EasyCredit creemos que el verdadero crecimiento financiero comienza con información clara, educación y confianza.',
    },
    {
      id: 'faq6',
      pregunta: '¿Qué necesito para solicitar un crédito con EasyCredit?',
      respuesta:
        'Debes ser mayor de edad, tener cédula de ciudadanía válida, una cuenta bancaria activa a tu nombre (no solo billetera digital), correo y celular propios. Completa tu solicitud con datos reales y verificables en nuestra plataforma.',
    },
    {
      id: 'faq7',
      pregunta: '¿Cómo funciona el proceso de solicitud y aprobación?',
      respuesta:
        'Solo debes ingresar a easycreditcolombia.com, crear tu perfil, llenar el formulario y esperar la evaluación. El resultado llega en menos de 24 horas hábiles. Si tu crédito es aprobado, firmas digitalmente y el dinero se desembolsa directamente a tu cuenta bancaria.',
    },
    {
      id: 'faq8',
      pregunta: '¿De cuánto puede ser mi crédito y en cuánto tiempo lo pago?',
      respuesta:
        'Tu monto y plazo dependen de tu historial y comportamiento:\n- Primer crédito: hasta $350.000 COP\n- Recurrentes: hasta $1.000.000 COP\n- Plazo: entre 5 y 30 días, con posibilidad de extender hasta 90 días según evaluación.',
    },
    {
      id: 'faq9',
      pregunta: '¿Puedo pedir un crédito si estoy reportado?',
      respuesta:
        'Sí. En EasyCredit analizamos tu perfil completo, no solo tu puntaje. Tener un reporte no significa rechazo automático, pero puede influir en el monto o la aprobación.',
    },
    {
      id: 'faq10',
      pregunta: '¿Qué pasa si no puedo pagar a tiempo o quiero pagar antes?',
      respuesta:
        'Si no puedes pagar en la fecha acordada, lo mejor es comunicarte con nosotros antes del vencimiento para ayudarte a encontrar una solución y evitar cargos adicionales. Puedes solicitar una extensión de plazo pagando los costos correspondientes. Si no realizas el pago o no llegas a un acuerdo, se generarán intereses de mora y cargos de cobranza, además de la posibilidad de ser reportado a las centrales de riesgo. En EasyCredit siempre buscamos acompañarte para que mantengas tu historial en buen estado y puedas volver a acceder a nuevos créditos.',
    },
    {
      id: 'faq11',
      pregunta: '¿Cómo y dónde puedo realizar mis pagos?',
      respuesta:
        'Los pagos se hacen exclusivamente por transferencia bancaria o PSE (ePayco). Usamos pasarelas seguras que garantizan la protección de tus datos y la confirmación del pago de forma segura.',
    },
    {
      id: 'faq12',
      pregunta: '¿EasyCredit reporta a las centrales de riesgo?',
      respuesta:
        'Sí. Reportamos tanto los pagos cumplidos como los atrasos ante Datacrédito Experian y TransUnion. Un buen comportamiento mejora tu puntaje y acceso a montos más altos.',
    },
    {
      id: 'faq13',
      pregunta: '¿Dónde puedo comunicarme si tengo dudas o reclamos?',
      respuesta:
        '📞 WhatsApp o teléfono: 317 365 8787\n📧 Correo: ayuda@easycreditcolombia.com\n🕐 Horario: Lunes a viernes 8:30 a. m. – 5:30 p. m.',
    },
  ];

  return (
    <Grid container className="contenedor_preguntas_frecuentes" id="preguntas-frecuentes">
      <Box sx={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        <Typography variant="h1" className="titulo_preguntas_frecuentes">
          Preguntas Frecuentes
        </Typography>

        <Box sx={{ marginTop: '3rem' }}>
          {faqs.map((faq, index) => (
            <Accordion
              key={faq.id}
              expanded={expanded === faq.id}
              onChange={handleChange(faq.id)}
              className="acordeon_faq"
              sx={{
                marginBottom: '1rem',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                borderRadius: '8px !important',
                '&:before': {
                  display: 'none',
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="icono_expand_faq" />}
                aria-controls={`${faq.id}-content`}
                id={`${faq.id}-header`}
                className="acordeon_summary"
                sx={{
                  padding: '1.5rem',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <Typography variant="h6" className="pregunta_faq">
                  {faq.pregunta}
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acordeon_details" sx={{ padding: '0 1.5rem 1.5rem 1.5rem' }}>
                <Typography
                  variant="body1"
                  className="respuesta_faq"
                  sx={{ whiteSpace: 'pre-line' }}
                >
                  {faq.respuesta}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Grid>
  );
};

export default PreguntasFrecuentes;

